import { z } from "zod";

/** What the agent may remember about a shopper who consented (ADR-13). Empty is off. */
export const MEMORY_KINDS = ["preferences", "dietary", "usual"] as const;
export type MemoryKind = (typeof MEMORY_KINDS)[number];

export const memorySchema = z
	.object({
		remember: z.array(z.enum(MEMORY_KINDS)).default([]),
	})
	.prefault({});
